import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InvestorDataService } from '../../../core/investor-data.service';
import { Investor } from '../../shared/models/investor';
import { ScorecardCalcService } from '../../../services/scorecard-calc.service';
import { DoughnutChartItem } from '../../shared/components/doughnut-chart/dought-item';
import { groupBy } from 'underscore';
import { availableGroupings } from '../asset-allocation/asset-allocation.component';
import * as html2pdf from 'html2pdf.js';
import * as _ from 'lodash';
@Component({
  selector: 'app-fin-report',
  templateUrl: './fin-report.component.html',
  styleUrls: ['./fin-report.component.css'],
})

export class FinReportComponent implements OnInit {
  uid: string;
  @Input()
  investor: Investor;
  score: number;

  liquidAssets: number;
  liability: number;
  retirementAssets: number;
  insurance: number;
  totalScore: number;

  liquidAssetsPercent: string;
  liabilityPercent: string;
  retirementAssetsPercent: string;
  insurancePercent: string;
  financialPercent: string;
  goals = [];
  expenseChart: Array<DoughnutChartItem>;
  currentAssetAllocationItems: Array<DoughnutChartItem>;
  assetLabels = {
    name: 'Assets',
    percent: 'Allocation',
    totals: 'Amount',
    return: 'Growth Rate'
  }
  expenseLabels = {
    name: 'Expenses',
    percent: 'Allocation',
    totals: 'Amount',
  }

  constructor(
    private _Activatedroute: ActivatedRoute,
    private manageInvestorService: InvestorDataService,
    private scoreCalc: ScorecardCalcService,
  ) {
    this.currentAssetAllocationItems = new Array();
    this.expenseChart = new Array();
  }

  getUpdatedAtDate(investor: Investor) {
    return new Date(investor.updatedAt.toString()).toDateString();
  }

  ngOnInit() {
    this.uid = this._Activatedroute.snapshot.params['uid'];
    if (!this.uid) {
      this.processData();
      return;
    }
    this.manageInvestorService
      .getInvestorByKey(this.uid)
      .get()
      .then((value) => {
        this.investor = new Investor(value.data());
        this.processData();
      });
  }

  getRiskTitle(risk: string) {
    switch (risk) {
      case ('conservative'):
      case ('moderate'):
      case ('aggressive'):
        return risk;
      case ('moderate_plus'):
        return 'moderate plus';
      case ('higly_aggressive'):
        return 'Highly Aggressive';
      default:
        return 'unknown';
    }
  }

  getDateInFormat(date: string) {
    const DOB = new Date(date);
    return (
      [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sept',
        'Oct',
        'Nov',
        'Dec',
      ][DOB.getMonth()] +
      ' ' +
      DOB.getDate() +
      ' ' +
      DOB.getFullYear()
    );
  }

  getAge(date: string): number {
    const DOB = new Date(date);
    if (DOB) {
      var ageDifMs = Date.now() - DOB.getTime();
      var ageDate = new Date(ageDifMs); // miliseconds from epoch
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    } else {
      return null;
    }
  }

  getOffset(el) {
    var _x = 0;
    var _y = 0;
    while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
      _x += el.offsetLeft - el.scrollLeft;
      _y += el.offsetTop - el.scrollTop;
      el = el.offsetParent;
    }
    return { top: _y, left: _x };
  }


  generateAttachment = function (uriString, fileName) {
    var uristringparts = uriString.split(',');
    uristringparts[0] = 'base64:' + fileName + '//';
    return uristringparts.join('');
  };

  getPriorityLabel(priority) {
    switch (priority) {
      case '3':
      case 3:
        return 'Low';
      case '2':
      case 2:
        return 'Medium';
      case '1':
      case 1:
        return 'High';
      default:
        return priority;
    }
  }

  makePDF2() {
    var data = document.getElementById('fin-report-pdf');
    var opt = {
      margin: [10, 0],
      filename:
        (this.investor
          ? this.investor.name
            ? this.investor.name + "'s "
            : "Investor's "
          : "Investor's ") + 'Financial Report.pdf',
      image: { type: 'png', quality: 1 },
      html2canvas: { scale: 1 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    };

    // New Promise-based usage:
    // html2pdf()
    //   .from(data)
    //   .set(opt)
    //   .outputPdf()
    //   .then((data1) => {
    //     const file = this.generateAttachment(data1, 'test.pdf');
    //     console.log(file);
    //     console.log(typeof file);
    //     // const file = new File([data], 'newFile.pdf', {type: 'pdf'});

    //     // console.log(typeof file);
    //     var mail = document.createElement('a');
    //     mail.href = 'mailto:bnap00@gmail.com?attachment=' + file;
    //     mail.click();
    //     // window.plugin.email.open({
    //     //   to: ['to@email.com'],
    //     //   subject: 'New PDF!',
    //     //   body: 'Hi there, here is that new PDF you wanted!',
    //     //   isHTML: false,
    //     //   attachments: [pdfBase64]
    //     // });
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    html2pdf()
      .from(data)
      .set(opt)
      .save()
  }

  processData() {
    this.score = this.scoreCalc.getScore(this.investor);
    this.liquidAssets = Math.round(this.scoreCalc.liquidAssets(this.investor));
    this.liability = Math.round(this.scoreCalc.liability(this.investor));
    this.retirementAssets = Math.round(
      this.scoreCalc.retirementAssets(this.investor),
    );
    this.insurance = Math.round(this.scoreCalc.insurance(this.investor));
    this.totalScore =
      this.liability +
      this.liquidAssets +
      this.retirementAssets +
      this.insurance +
      100;
    this.liquidAssetsPercent =
      Math.round((this.liquidAssets / this.totalScore) * 100) + '%';
    this.liabilityPercent =
      Math.round((this.liability / this.totalScore) * 100) + '%';
    this.retirementAssetsPercent =
      Math.round((this.retirementAssets / this.totalScore) * 100) + '%';
    this.insurancePercent =
      Math.round((this.insurance / this.totalScore) * 100) + '%';
    this.financialPercent = Math.round((100 / this.totalScore) * 100) + '%';
    Object.keys(this.investor.goals).map((itemKey) => {
      this.investor.goals[itemKey] = _.filter(
        this.investor.goals[itemKey],
        (goal) => goal.target_amount != null,
      );
    });
    const assetAllocationGroups = groupBy(
      this.investor.assets,
      'asset_allocation_type',
    );
    this.currentAssetAllocationItems = availableGroupings.map(group => {
      const assets = assetAllocationGroups[group.group] || [];
      const assetsTotal = assets.map(a => parseInt(a.value) || 0).reduce((val1, val2) => val1 + val2, 0) || 0;
      const assetsReturns = assets.map(a => parseInt(a.return_percentage + "")).reduce((val1, val2) => val1 + val2, 0) || 0;
      let percent = 0;
      console.log(assetsReturns, assets);
      if (assetsReturns > 0 && assetsTotal > 0) {
        percent = Math.floor((assetsReturns / assets.length) * 100) / 100
      }
      return new DoughnutChartItem(group.name, assetsTotal, group.color, percent);
    });
    // this.currentAssetAllocationItems = availableGroupings.map((group) => {
    //   const assets = assetAllocationGroups[group.group] || [];
    //   const assetsTotal =
    //     assets
    //       .map((a) => parseInt(a.value) || 0)
    //       .reduce((val1, val2) => val1 + val2, 0) || 0;
    //   const assetsReturns =
    //     assets
    //       .map((a) => a.return_percentage)
    //       .reduce((val1, val2) => val1 + val2, 0) || 0;
    //   let percent = 0;
    //   console.log(assetsReturns, assets);
    //   if (assetsReturns > 0 && assetsTotal > 0) {
    //     percent = Math.floor((assetsReturns / assets.length) * 100) / 100;
    //   }
    //   return new DoughnutChartItem(group.name, assetsTotal, group.color, percent);
    //   // return new DoughnutChartItem(
    //   //   group.name,
    //   //   assetsTotal,
    //   //   group.color,
    //   //   assetsReturns,
    //   // );
    // });

    var expenses = this.investor.expenses['main'].map((element) => {
      return element;
    });
    if (
      this.investor.expenses['spouse'] != null ||
      typeof this.investor.expenses['spouse'] != 'undefined'
    ) {
      this.investor.expenses['spouse'].forEach((element, index) => {
        expenses[index].value =
          (expenses[index].value || 0) + (element.value || 0);
      });
    }
    this.expenseChart = expenses
      .filter((item) => {
        return !(item.value <= 0);
      })
      .map((expense, index) => {
        return new DoughnutChartItem(
          expense.label,
          expense.value,
          colors[index],
          0,
        );
      });
    console.log(this.investor.goals);
    Object.keys(this.investor.goals).forEach((goal) => {
      this.goals = Array.prototype.concat(
        this.goals,
        this.investor.goals[goal],
      );
    });
    this.goals.sort(sortByNumerical('priority'));
    console.log(this.goals);
  }

  getTotalAssetsValue() {
    return this.investor.assets
      .map((a) => parseInt(a.value) || 0)
      .reduce((val1, val2) => val1 + val2, 0);
  }

  getTotalAssetsReturnsValue() {
    return this.investor.assets
      .map((a) => ((parseInt(a.value) || 0) * a.return_percentage) / 100.0)
      .reduce((val1, val2) => val1 + val2, 0);
  }

  getTotalAssetsReturnsPercentage() {
    // console.log("here");
    return (
      (this.getTotalAssetsReturnsValue() / this.getTotalAssetsValue()) * 100
    );
  }
}

export function sortByNumerical(field) {
  return function (a, b) {
    if (a[field] > b[field]) return 1;
    if (a[field] < b[field]) return -1;
    return 0;
  };
}

const colors = [
  '#7B241C',
  '#943126',
  '#633974',
  '#5B2C6F',
  '#1A5276',
  '#21618C',
  '#117864',
  '#0E6655',
  '#1D8348',
  '#9A7D0A',
  '#9C640C',
  '#935116',
  '#873600',
  '#979A9A',
  '#797D7F',
  '#212F3C',
  '#1C2833',
];



// WEBPACK FOOTER //
// ./src/app/modules/hwcheckup/fin-report/fin-report.component.ts